import script from "./TableChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./TableChart.vue?vue&type=script&setup=true&lang=ts"

import "./TableChart.vue?vue&type=style&index=0&id=5d1459ff&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d1459ff"]])

export default __exports__